<script setup>
import { ref, defineProps, onMounted } from 'vue'

const props = defineProps(['field'])
const field = ref(props.field)

const ImageType = ref(null);
const Images = ref([]);

onMounted(() => {
  onChangeCanvasImageType("RGB");
})

// キャンバス内の画像種別変更イベント
function onChangeCanvasImageType(type) {
  ImageType.value = type;
  reloadOffCanvas(field.value);
}

// キャンバス再描画処理
function reloadOffCanvas(field) {
  Images.value = [];

  let shootingDays = field?.ShootingDays?.find(e => e.id === "DJI");
  if (shootingDays && shootingDays?.Days) {
    shootingDays.Days.forEach(function(day){
      Images.value.push(
        "https://sams-famisuke-dev-google-map-images.s3.ap-northeast-1.amazonaws.com"
          + "/DJI"
          + "/" + field.id
          + "/" + ImageType.value
          + "/" + day
          + ".png"
      );
    });
  }
  // if (shootingDays && shootingDays?.Days) {
  //   shootingDays.Days.forEach(function(day){
  //     Images.value.push(
  //       "https://sams-famisuke-dev-map-images.s3.ap-northeast-1.amazonaws.com"
  //         + "/DJI"
  //         + "/" + field.id
  //         + "/" + ImageType.value
  //         + "/" + day
  //         + "/Resize"
  //         + "/T_image.png"
  //     );
  //   });
  // }
}

// ウィンドウ表示処理（画像クリック時に使用）
function openWindow(img) {
  window.open(img, "_blank", "width=866,height=580,location=no");
}

</script>

<template>
  <div class="btn-group btn-group-sm w-100 d-flex flex-row p-2" role="group" aria-label="Basic radio toggle button group">
    <input type="radio" class="btn-check" name="canvasBtnRadio" id="canvasBtnRgb" value="RGB" @change="onChangeCanvasImageType('RGB')" checked>
    <label class="btn btn-outline-primary" for="canvasBtnRgb">RGB</label>

    <input type="radio" class="btn-check" name="canvasBtnRadio" id="canvasBtnNdvi" value="NDVI" @change="onChangeCanvasImageType('NDVI')" >
    <label class="btn btn-outline-primary" for="canvasBtnNdvi" data-bs-placement="bottom" 
      title="この指標は、植生のクロロフィル(葉緑素)含有量に対して最も一般的に使用される指標であり、植生の初期～中期における成長と栄養素に関する情報を提供します。この指標を使用して植生の成長状況と範囲を監視することが出来ます。">
      NDVI
    </label>

    <input type="radio" class="btn-check" name="canvasBtnRadio" id="canvasBtnGndvi" value="GNDVI" @change="onChangeCanvasImageType('GNDVI')" >
    <label class="btn btn-outline-primary" for="canvasBtnGndvi" data-bs-placement="bottom"
      title="この指標は、NDVIで使用される赤色バンドの代わりに緑色バンドを使用します。緑色バンドは表面のGNDVIを表し、植生が水不足、栄養不足、または成長後のバイオマス不足に苦しんでいるかどうかを示すことが出来ます。">
      GNDVI
    </label>

    <input type="radio" class="btn-check" name="canvasBtnRadio" id="canvasBtnLci" value="LCI" @change="onChangeCanvasImageType('LCI')" >
    <label class="btn btn-outline-primary" for="canvasBtnLci" data-bs-placement="bottom"
      title="この指標は葉のクロロフィル含有量であり、植生の成長と収穫量を評価するための重要な指標です。同時に、植物の栄養ストレス、病気、および老化を評価するための指標でもあります。">
      LCI
    </label>
    
    <input type="radio" class="btn-check" name="canvasBtnRadio" id="canvasBtnNdre" value="NDRE" @change="onChangeCanvasImageType('NDRE')" >
    <label class="btn btn-outline-primary" for="canvasBtnNdre" data-bs-placement="bottom"
      title="この指標は、NDVIで使用されている赤色エッジバンドに代わる赤色エッジバンドが使用されます。この赤色エッジバンドは、赤色スペクトルから近赤外スペクトルへの遷移区域のスペクトル領域です。NDREは、クロロフィルや糖度などの変数に基づいて植生の後期における健康を管理するために使用されます。">
      NDRE
    </label>

    <input type="radio" class="btn-check" name="canvasBtnRadio" id="canvasBtnOsavi" value="OSAVI" @change="onChangeCanvasImageType('OSAVI')" >
    <label class="btn btn-outline-primary" for="canvasBtnOsavi" data-bs-placement="bottom"
      title="この指標は土壌調整植生指数であり、NDVIおよび関連する観測データに基づいています。この指標は、植生に対する土壌状態の影響を排除するために使用されます。">
      OSAVI
    </label>
  </div>

  <div class="list-group overflow-y-scroll" id="image-list" role="tablist">
    <a class="list-group-item list-group-item-action p-0" v-for="(image, index) in Images" :key="index">
      <div class="card text-center rounded-0">
        <div class="card-header p-0">
          <h6 class="m-0">{{ image.slice(-12).slice(0, 4) }}/{{ image.slice(-12).slice(4, 6) }}/{{ image.slice(-12).slice(6, 8) }}</h6>
        </div>
        <img :src="image" class="card-img-top" @click="openWindow(image.replace('T_image.png', 'image.png'))">
      </div>
    </a>
  </div>
</template>

<style scoped>
.list-group {
  height: 85vh;
}
</style>
